import { Navigate, useLocation } from 'react-router-dom';
import type { ErpModule } from '@/api/platform.api';
import { legacyWorkRedirectTarget, moduleWorkPath } from '@/config/moduleWorkPaths';
import { useActiveModule } from '@/hooks/useActiveModule';
import { useAppSelector } from '@/hooks/useAppSelector';

export function LegacyWorkRouteRedirect({ fallbackModule = 'POS' }: { fallbackModule?: ErpModule }) {
  const location = useLocation();
  const activeModule = useActiveModule();
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const module = activeModule ?? entryModule ?? fallbackModule;
  const target = legacyWorkRedirectTarget(location.pathname, module) ?? moduleWorkPath(module);
  return <Navigate to={`${target}${location.search}`} replace />;
}
